const isPrimitiveType = (val, type) => Object.prototype.toString.call(val) === type

export function isObject (val) {
  return isPrimitiveType(val, '[object Object]')
}
export function calcTimer (totalSec) {
  let remainingSec = totalSec
  const dd = Math.floor(totalSec / 24 / 3600)
  remainingSec -= dd * 3600 * 24
  const hh = Math.floor(remainingSec / 3600)
  remainingSec -= hh * 3600
  const mm = Math.floor(remainingSec / 60)
  remainingSec -= mm * 60
  const ss = Math.floor(remainingSec)

  return {
    dd,
    hh,
    mm,
    ss
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js